export const MOVE_VERSION = "fr_FR_3.0.0"
export const initItem = {
  item: "",
  audio: false,
  item_id: 0,
  proposals: [
    {
      proposal: "",
      proposal_id: "",
    },
    {
      proposal: "",
      proposal_id: "",
    },
    {
      proposal: "",
      proposal_id: "",
    },
    {
      proposal: "",
      proposal_id: "",
    },
  ],
}

export const initExtra = {
  native_language: true, // TODO: remove when backend no longer requires it
  wholesome_conditions: true, // TODO: remove when backend no longer requires it
  finished: false,
  isRestarting: undefined,
  elapsed_time: 0,
  general_audio: false,
}

export const initAnswers = {
  version: "",
  langCode: "",
  locale_id: 0,
  status: "",
  data: {
    items: [],
    extra: initExtra,
  },
}

const factoryItem = (id: number) => ({
  answer: `pe_proposal_02`,
  audio: false,
  device_type: "desktop",
  item_id: id,
  screen_width: 1920,
  time_initial: 0.2,
})

export const factoryPatch = {
  version: "fr_FR_3.0.0",
  langCode: "en_US",
  locale_id: 3,
  status: "inprogress",
  data: {
    items: [
      factoryItem(607),
      factoryItem(608),
      factoryItem(615),
      factoryItem(619),
      factoryItem(623),
      factoryItem(624),
      factoryItem(631),
      factoryItem(635),
      factoryItem(639),
      factoryItem(643),
      factoryItem(647),
      factoryItem(651),
      factoryItem(655),
      factoryItem(659),
      factoryItem(660),
      factoryItem(661),
      factoryItem(663),
      factoryItem(664),
      factoryItem(671),
      factoryItem(675),
      factoryItem(679),
      factoryItem(680),
      factoryItem(687),
      factoryItem(691),
      factoryItem(695),
      factoryItem(699),
      factoryItem(703),
      factoryItem(707),
      factoryItem(711),
      factoryItem(715),
      factoryItem(716),
      factoryItem(717),
      factoryItem(719),
      factoryItem(720),
      factoryItem(727),
      factoryItem(731),
      factoryItem(735),
      factoryItem(736),
      factoryItem(743),
      factoryItem(747),
      factoryItem(751),
      factoryItem(755),
      factoryItem(759),
      factoryItem(763),
      factoryItem(767),
      factoryItem(771),
    ],
    extra: { ...initExtra },
  },
}

export const factoryReset = {
  version: "fr_FR_3.0.0",
  langCode: "en_US",
  locale_id: 3,
  status: "todo",
  data: {
    items: [],
    extra: { ...initExtra },
  },
}
